import { api } from '../helpers';

export const getMaster = (_, token) => {
	return api('/Master/GetMasterData', 'GET', null, null, token);
};
